export { default } from './YandexMap';
